import type { CommentThreadContextType } from './CommentThreadContext.ts';
import { use } from 'react';
import { CommentThreadContext } from './CommentThreadContext.ts';

export function useCommentThread<TComment>() {
  const context = use(CommentThreadContext as React.Context<CommentThreadContextType<TComment>>);

  if (!context) {
    throw new Error(`useCommentThread needs to be used inside <CommentThreadProvider>`);
  }

  return context;
}
